import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex w-full rounded-lg bg-[#EEEEEE] p-2 xsm:px-4" }
const _hoisted_2 = { class: "mr-1 w-3/4 xsm:mr-0" }
const _hoisted_3 = {
  key: 0,
  class: "my-1 text-xs text-gray-500"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "mt-6 flex w-1/4 items-center justify-end" }
const _hoisted_6 = {
  key: 0,
  class: "loading loading-spinner loading-md mx-auto"
}
const _hoisted_7 = {
  key: 1,
  class: "flex gap-x-2 font-medium"
}
const _hoisted_8 = ["disabled"]

import {
  CheckIcon,
  XMarkIcon,
} from '@heroicons/vue/24/outline';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import {
  onMounted,
  ref,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EditTitleForm',
  props: {
  createdAt: {
    type: String,
    default: '',
  },
  text: {
    type: String,
    required: true,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
},
  emits: ["confirm", "cancel"],
  setup(__props) {

dayjs.extend(localizedFormat);



const props = __props;

const titleEditInput = ref<HTMLInputElement | null>(null);

const inputText = ref<string>(props.text);

onMounted(() => {
  titleEditInput.value?.focus();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.createdAt)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(dayjs)(__props.createdAt).format('lll')), 1))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("input", {
        ref_key: "titleEditInput",
        ref: titleEditInput,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputText).value = $event)),
        type: "text",
        class: "input-1 h-9 w-[90%] xsm:w-full",
        disabled: __props.isLoading
      }, null, 8, _hoisted_4), [
        [_vModelText, inputText.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (__props.isLoading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["rounded-full border-2 p-2 text-gray-400", { 'bg-blue-1 text-white hover:bg-blue-2': inputText.value }]),
              disabled: !inputText.value,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm', inputText.value)))
            }, [
              _createVNode(_unref(CheckIcon), { class: "size-4" })
            ], 10, _hoisted_8),
            _createElementVNode("button", {
              type: "button",
              class: "rounded-full border-1 border-gray-500 p-2 hover:bg-red-500",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('cancel')))
            }, [
              _createVNode(_unref(XMarkIcon), { class: "size-4" })
            ])
          ]))
    ])
  ]))
}
}

})